import React from 'react';
import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../utils/auth';

/**
 * 受保护的路由组件
 * 检查用户是否已登录，未登录则重定向到登录页
 */
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = isLoggedIn();
  
  if (!isAuthenticated) {
    // 清空可能残留的认证信息
    localStorage.clear();
    sessionStorage.clear();
    
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
